import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';


@Component({
  selector: 'app-myob-payments-grid-invoice',
  templateUrl: './myob-payments-grid-invoice.component.html',
  styleUrls: ['./myob-payments-grid-invoice.component.scss']
})
export class MyobPaymentsGridInvoiceComponent implements OnInit {



  @Input() sent_data?: any; // not used

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;


     // setup as observable?
     @Input() item_id?; // impliments on changes.
     @Input() invoice_number?; // impliments on changes.
     @Input() myob_payment_id?; // impliments on changes.
     
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full


  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  myobCustomerCreatedData: any;
  brand_types: any;
  users: any;
  usersPrimary: any;
  job_table_clients: any;
  btLocalRecord: any;
  changeObject: any;
  userLocalRecord: any;
  job_table_clients3: any;
  UID_new_customer: any;
  returned_update: Object;
  myobCustomerDeleteData: Object;
  myobCustomerUpdateData: Object;
  customerItem: any;
  myobContactListMapped: any;
  myobCustomer: Object;
  set_RowVersion: any;
  IsIndividual: any;
  myobInvoices: Object;
  myobInvoiceDeleteData: Object;
  myobInvoice: Object;
  invoiceItem: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  accountsLocalRecord: any;
  myob_account_codes: Object;
  myob_account_codes_by_UID: any;
  updated_myob_account: Object;
  created_myob_account: Object;
  myob_acount_code_live: Object;
  myob_acount_codes_live: Object;
  sent_data_stringify: string;
  myob_payments_live: Object;
  myob_invoice_id: Observable<any[]>;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) {
   

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

    // need to add this as routes does not work globally
    this.all_router_details = this.router.url;
    this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


   }

   // check for changes. to load data.
   ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.item_id = changes.item_id.currentValue;
      
      // this.getJob(this.job_id);
      this.myob_invoice_id = this.item_id;
    

      this.getMyobCustomerPaymerntsLive();
      // lpad these for merge conidtions
              this.getMyobAccountCodes(); // local


    }
  }




  ngOnInit() {

// load the SOP Brands/Clients
// this.mapJobTableLiveClients();

    // Load the data
          this.getMyobCustomerPaymerntsLive();
// lpad these for merge conidtions
        this.getMyobAccountCodes(); // local

          // Grid Options
          this.toolbarOptions = ['ExcelExport', 'Search'];
          this.initialPage = { pageSize:5 };
          this.filterOptions = {
             type: 'Menu'
          };
         // this.groupOptions = { columns: [''] }; // sets auto grouping for the grid
          this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
          this.dateFormat = 'dd/MM/yyyy hh:mm a';
          this.filter = { params: { format: this.dateFormat } };
        //  this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
      
      
      // end date filter options
          // End Grid Options
  }



  // :: Grid Functions


// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);

   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

};


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

  // :: Grid Functions


  // uses demo services but calls to myob
  public getMyobInvoices() {
    return  this._demoService.getMyobInvoices().subscribe(
        data => { this.myobInvoices = data;
          const res = data[0];
           // https://www.concretepage.com/questions/577
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.Items = data['Items'] ;
           this.sent_data = this.Items;
  
           // console.log(this.Items);
          // this.Address = this.Items['Address'];
    // return this.myobCustomers;
  
    // Map the data top the new model system
   // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );
  
    }



    public getMyobCustomerPaymerntsLive() {
      return  this._demoService.getMyobCustomerPaymerntsLive().subscribe(
          data => { this.myob_payments_live = data;
            const res = data[0];
             // https://www.concretepage.com/questions/577
             this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
             // console.log(this.arrCase);
             this.Items = data['Items'] ;
             this.sent_data = this.Items;
            //  this.sent_data_stringify = JSON.stringify(this.sent_data);
    
             // console.log(this.Items);
            // this.Address = this.Items['Address'];
      // return this.myobCustomers;
    
      // Map the data top the new model system
     // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));

            // Filters
     const InvoicePaymentsFiltered = Object(this.sent_data).filter((ac) => (ac.Invoices[0].Number === this.invoice_number)); 
     this.sent_data = InvoicePaymentsFiltered;
              // Filter the Objects... If invoice_number = this invoice_number // Show Payments
              //  -- and invoice_payment_UID == invoice payment id locally -- mark as joined...
              // otherwise -- mark as an "OVER PAYMENT if no link back......."

    
          },
          err => {
            // this.toastr.error('You need to login to MYOB again, Connection lost!');
           // console.error(err);
          },
          // () => console.log('done loading Trace Types')
        );
    
      }





refreshGrid(){ // refresh the databutton
  // this.loadList(this.doc_id);
  this.getMyobCustomerPaymerntsLive();
  this.grid.refresh();
};
  
  // need to change this below
  editBrand(model){
    // model.job_id = this.job_id;
     this._demoService.updateBrand(model).subscribe(
       data => {  // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Company Updated');
       this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error Updating Brand');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
   );}
  
  
  
// delay function
delay(ms: number) {
  return new Promise( resolve => setTimeout(resolve, ms) );
}




  updatePushMyobAcccountsLivetoLocal(model) {

    // console.log('Live Modek: ' + JSON.stringify(model));
    // :: Get list of all live,
// two filter local myob_accounts for: Update - ones with UID and insert ones without UID's;
// with these two filters run the update or select statements looping thorugh the model records.

// get user counts per brand
const newArr = Object(model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
const  count_of_items = Object.keys(newArr).length;
//  let res = data[0];
// Run the job data queries.

// let localAccountsNotLInkedArr = Object(this.myob_account_codes).filter((ac)=>(ac.UID === null)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
// let localAccountsLInkedArr = Object(this.myob_account_codes).filter((ac)=>(ac.UID != null)); // sbi.invoice_status === 'NOT-INVOICED'- old filter

// need to do a loop of subject_billing items (.length)
       for (let i = 0; i < count_of_items; i++) {
            let res = newArr[i];

            console.log('Row: ' + i);
            console.log('Item: ' + res.Name );

            // lookup myob accounts row with UID = local UID then filter  and count the rows. then access array for variables.
            const localAccountsLInkedArr = Object(this.myob_account_codes).filter((ac)=>(ac.UID === res.UID)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
            console.log('LocalCheckCount: ' + localAccountsLInkedArr.length );
            const local_account_check_length = localAccountsLInkedArr.length;

            // set the local myob_account_code_id for new_model.
            let local_myob_account_code_id;
            if (local_account_check_length === 1) {
            local_myob_account_code_id = localAccountsLInkedArr[0].myob_account_code_id;
            }else {
              local_myob_account_code_id = null;
            }


            // stops erros of undefined in objects of objects. - set as vars and set if conditions
            let TaxCode;
            let TaxUID;
            if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
              TaxCode = null;
              TaxUID = null;
            }else {
              TaxCode = res.TaxCode.Code; // can only call if actuall exist in the array!
              TaxUID = res.TaxCode.UID;
            };

            // clear first
            let new_model = null;
            // :: Build New moedel
            new_model = {
              myob_account_code_id: local_myob_account_code_id,
              myob_account_code_name: res.Name,
              myob_account_code_code: res.DisplayID,
              myob_account_id: res.UID,
              Name: res.Name,
              DisplayID: res.DisplayID,
              Type: res.Type,
              Classification: res.Classification,
              UID: res.UID,
              TaxCodeCode: TaxCode, // special var
              TaxCodeUID: TaxUID,  // special var
              LastModified: res.LastModified,
              RowVersion: res.RowVersion,
              myob_array: JSON.stringify(newArr[i])
            }; // multidimentional array push
            // console.log('New Model: ' + JSON.stringify(new_model));



                                // if the display codes exist the same.
                                if (local_account_check_length === 1) {
                                        // RUn the update record
                                        // console.log('Updated: ' + res.UID + ' ' + res.Name + ' LocalMAC_ID: '
                                        //  + localAccountsLInkedArr[0].myob_account_code_id);
                                        console.log('Updated: ' + res.UID + ' ' + res.Name + ' LocalMAC_ID: '
                                        + local_myob_account_code_id);
                                        // this.updateMyobAccountCodes(new_model, local_myob_account_code_id);
                                } else if (local_account_check_length === 0) {
                                        // run the insert record
                                        console.log('Inserted: ' + res.UID + ' ' + res.Name);
                                        this.createMyobAccountCodes(new_model);
                                }


            // this.checkForLocalMyobAccountUID();
            // if no records insert new row.

            // two filter local myob_accounts for: Update - ones with UID and insert ones without UID's;
            // with these two filters run the update or select statements looping thorugh the model records.



            } // end loop

    // :: lloop through list
    // :: On loop luukup if eists - update
    // :: Look up if not exists - insert.

    // Refresh below grid Items
    this.toastr.success('Successfully Imported and Synced Account Code Data From Live to Local.');
    // refresh the local account codes call after upgrdes and inserts
    // this.getMyobAccountCodes();

  };






  updateMyobAccountCodes(model, myob_account_code_id) {
    this._demoService.updateMyobAccountCodes(model, myob_account_code_id).subscribe(
      data => {   this.updated_myob_account = data; // this is the retuned json upon creation.
        //  let res = data[0];
    // this.toastr.success('Invoice Updated');
    //  return true;
      },
      error => {
        console.error(error);
      });
   };



   createMyobAccountCodes(model) {
    this._demoService.createMyobAccountCodes(model).subscribe(
      data => {   this.created_myob_account = data; // this is the retuned json upon creation.
        //  let res = data[0];
    this.toastr.success('Account Created Locally');
     // return true;
      },
      error => {
        console.error(error);
      });
   };



   
   createMyobAccountCodesImport(model) {

    let TaxCode;
    let TaxUID;
    if (typeof model.TaxCode === 'undefined' || model.TaxCode === null ) {
      TaxCode = null;
      TaxUID = null;
    }else {
      TaxCode = model.TaxCode.Code; // can only call if actuall exist in the array!
      TaxUID = model.TaxCode.UID;
    };

    let new_model = null;
    // :: Build New moedel
    new_model = {
      // myob_account_code_id: local_myob_account_code_id,
      myob_account_code_name: model.Name,
      myob_account_code_code: model.DisplayID,
      myob_account_id: model.UID,
      Name: model.Name,
      DisplayID: model.DisplayID,
      Type: model.Type,
      Classification: model.Classification,
      UID: model.UID,
      TaxCodeCode: TaxCode, // special var
      TaxCodeUID: TaxUID,  // special var
      LastModified: model.LastModified,
      RowVersion: model.RowVersion,
      myob_array: JSON.stringify(model)
    }; // multidimentional array push

// run an external function to check the vaule - does not run before function not working
// const check_val =  this.checkForLocalMyobAccountUID(model.UID);
// console.log('Checked Value: ' + JSON.stringify(check_val));

// lookup myob accounts row with UID = local UID then filter  and count the rows. then access array for variables.
// tslint:disable-next-line:max-line-length
const localAccountsLInkedArr = Object(this.myob_account_codes).filter((ac) => (ac.UID === model.UID)); // filter array of already looked up myob_account_codes data
console.log('LocalCheckCount: ' + localAccountsLInkedArr.length );
const local_account_check_length = localAccountsLInkedArr.length;

            if (local_account_check_length === null || local_account_check_length === 0) {
              console.log('We need to create this one.');
                  this._demoService.createMyobAccountCodes(new_model).subscribe(
                    data => {   this.created_myob_account = data; // this is the retuned json upon creation.
                      //  let res = data[0];
                  this.toastr.success('Account Created Locally');
                  // return true;
                    },
                    error => {
                      console.error(error);
                    });

            } else {
              console.log('We need to UPDATE this one');
                      const local_myob_account_code_id = localAccountsLInkedArr[0].myob_account_code_id;
                      this._demoService.updateMyobAccountCodes(new_model, local_myob_account_code_id).subscribe(
                        data => {   this.updated_myob_account = data; // this is the retuned json upon creation.
                          //  let res = data[0];
                      this.toastr.success('Account Imported and Updated');
                      //  return true;
                        },
                        error => {
                          console.error(error);
                        });

            }
this.getMyobAccountCodes(); // need to refresh the loop model for next press otherwise does not know of updates to myob_account_codes
   };




  checkForLocalMyobAccountUID(UID){
    this._demoService.checkForLocalMyobAccountUID(UID).subscribe(
      data => { this.myob_account_codes_by_UID = data;
       let res = data[0];
       // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
       // // console.log(this.arrCase);
       // this.Items = data['Items'] ;
       // this.sent_data = this.Items;
       // this.sent_data = this.myob_account_codes;
this.toastr.info('Checked if account exists locally');
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  
  };


  getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        let res = data[0];

        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



}
